import { Box, Text, Columns, Column, ContentBlock } from 'braid-design-system';
import React from 'react';

import { encodeSvg } from 'src/shared/helpers';

import iconAd from './img/CandidateShortlist.svg';
import iconTick from './img/Profile2.svg';
import iconBulb from './img/SuccessHifive.svg';

import * as styles from './Highlights.css';

const Highlights = () => (
  <ContentBlock>
    <Box paddingX="gutter" paddingBottom="large">
      <Columns space="large" collapseBelow="desktop">
        <Column>
          <Box textAlign="center">
            <Box
              className={styles.svg}
              style={{
                backgroundImage: encodeSvg(iconAd),
              }}
            />
            <Box paddingX="small">
              <Text>We write and post your ad to save you time</Text>
            </Box>
          </Box>
        </Column>
        <Column>
          <Box textAlign="center">
            <Box
              className={styles.svg}
              style={{
                backgroundImage: encodeSvg(iconBulb),
              }}
            />
            <Text>
              We use SEEK tools and insights to maximise your ad performance
            </Text>
          </Box>
        </Column>
        <Column>
          <Box textAlign="center">
            <Box
              className={styles.svg}
              style={{
                backgroundImage: encodeSvg(iconTick),
              }}
            />
            <Text>We optimise your ad to attract the right candidate</Text>
          </Box>
        </Column>
      </Columns>
    </Box>
  </ContentBlock>
);
export default Highlights;
